export default __webpack_public_path__ + "static/media/icon-timesheet-management.cee65210.svg";